import { SCHEDULE_LATER } from "./NewsletterScheduleSection";
import { isCompleteDatetimeLocal } from "../../../../utils/newsletterDateUtils";

export const SCHEDULE_AT_REQUIRED_MESSAGE = "Seleziona data e ora per l'invio programmato.";

export const getScheduleAtValidationError = (scheduleMode, scheduledAt) => {
  if (scheduleMode === SCHEDULE_LATER && !isCompleteDatetimeLocal(scheduledAt)) {
    return SCHEDULE_AT_REQUIRED_MESSAGE;
  }
  return "";
};
